 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chunk-admin":"chunk-admin","chunk-analyze~chunk-area-embed~chunk-bar-embed~chunk-pie-embed~chunk-projections~chunk-share~client-~87dfe4db":"chunk-analyze~chunk-area-embed~chunk-bar-embed~chunk-pie-embed~chunk-projections~chunk-share~client-~87dfe4db","chunk-analyze~chunk-pie-embed~chunk-share":"chunk-analyze~chunk-pie-embed~chunk-share","chunk-analyze~chunk-share":"chunk-analyze~chunk-share","chunk-analyze":"chunk-analyze","chunk-share":"chunk-share","chunk-pie-embed":"chunk-pie-embed","chunk-area-embed":"chunk-area-embed","chunk-bar-embed":"chunk-bar-embed","chunk-category-settings~client-chunk-about~client-chunk-entries":"chunk-category-settings~client-chunk-about~client-chunk-entries","client-chunk-about~client-chunk-entries~client-chunk-goals":"client-chunk-about~client-chunk-entries~client-chunk-goals","client-chunk-entries":"client-chunk-entries","client-chunk-about":"client-chunk-about","chunk-projections":"chunk-projections","client-chunk-avocados":"client-chunk-avocados","chunk-billing":"chunk-billing","chunk-category-settings~client-chunk-entry-editor":"chunk-category-settings~client-chunk-entry-editor","chunk-category-settings":"chunk-category-settings","client-chunk-entry-editor":"client-chunk-entry-editor","chunk-firestore":"chunk-firestore","chunk-xlsx-parser~chunk-zipcelx":"chunk-xlsx-parser~chunk-zipcelx","chunk-zipcelx":"chunk-zipcelx","client-chunk-about-sharesight":"client-chunk-about-sharesight","client-chunk-goals":"client-chunk-goals","client-chunk-appboot":"client-chunk-appboot","client-chunk-authentication":"client-chunk-authentication","client-chunk-calculator":"client-chunk-calculator","client-chunk-export":"client-chunk-export","client-chunk-import":"client-chunk-import","client-chunk-integrations":"client-chunk-integrations","client-chunk-legal":"client-chunk-legal","client-chunk-mail-preferences":"client-chunk-mail-preferences","client-chunk-plans":"client-chunk-plans","client-chunk-sharesight":"client-chunk-sharesight","client-chunk-user-email-invalid":"client-chunk-user-email-invalid","client-chunk-user-settings":"client-chunk-user-settings","chunk-xlsx-parser":"chunk-xlsx-parser"}[chunkId]||chunkId) + "." + {"chunk-admin":"f623bf20","chunk-analyze~chunk-area-embed~chunk-bar-embed~chunk-pie-embed~chunk-projections~chunk-share~client-~87dfe4db":"c89b7aa7","chunk-analyze~chunk-pie-embed~chunk-share":"34dde15d","chunk-analyze~chunk-share":"04f4ffd6","chunk-analyze":"dbbe2132","chunk-share":"25870d8b","chunk-pie-embed":"352c5173","chunk-area-embed":"7708bd4f","chunk-bar-embed":"1e7eca39","chunk-category-settings~client-chunk-about~client-chunk-entries":"9a45960c","client-chunk-about~client-chunk-entries~client-chunk-goals":"9b238775","client-chunk-entries":"8171f6d7","client-chunk-about":"f2cb4432","chunk-projections":"1521b14c","client-chunk-avocados":"d5021379","chunk-billing":"9b390797","chunk-category-settings~client-chunk-entry-editor":"2fdf8bca","chunk-category-settings":"e436c4f0","client-chunk-entry-editor":"29c20cb6","chunk-firestore":"ffdab242","chunk-xlsx-parser~chunk-zipcelx":"14dd3078","chunk-zipcelx":"cdb7ca27","client-chunk-about-sharesight":"b1f9ee27","client-chunk-goals":"8fcc1046","client-chunk-appboot":"fef7ce6a","client-chunk-authentication":"c5e559f6","client-chunk-calculator":"22369334","client-chunk-export":"98f9faef","client-chunk-import":"186a2bd0","client-chunk-integrations":"1a37ed2e","client-chunk-legal":"e8fc9383","client-chunk-mail-preferences":"226c9a13","client-chunk-plans":"8e7b35e5","client-chunk-sharesight":"910f0df6","client-chunk-user-email-invalid":"caf26cfa","client-chunk-user-settings":"a82e3b70","chunk-xlsx-parser":"57139032"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-admin":1,"chunk-analyze~chunk-share":1,"chunk-analyze":1,"chunk-share":1,"chunk-pie-embed":1,"chunk-area-embed":1,"chunk-bar-embed":1,"chunk-category-settings~client-chunk-about~client-chunk-entries":1,"client-chunk-about~client-chunk-entries~client-chunk-goals":1,"client-chunk-entries":1,"client-chunk-about":1,"chunk-projections":1,"client-chunk-avocados":1,"chunk-billing":1,"chunk-category-settings~client-chunk-entry-editor":1,"chunk-category-settings":1,"client-chunk-entry-editor":1,"client-chunk-about-sharesight":1,"client-chunk-goals":1,"client-chunk-appboot":1,"client-chunk-authentication":1,"client-chunk-calculator":1,"client-chunk-export":1,"client-chunk-import":1,"client-chunk-integrations":1,"client-chunk-legal":1,"client-chunk-mail-preferences":1,"client-chunk-plans":1,"client-chunk-sharesight":1,"client-chunk-user-settings":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chunk-admin":"chunk-admin","chunk-analyze~chunk-area-embed~chunk-bar-embed~chunk-pie-embed~chunk-projections~chunk-share~client-~87dfe4db":"chunk-analyze~chunk-area-embed~chunk-bar-embed~chunk-pie-embed~chunk-projections~chunk-share~client-~87dfe4db","chunk-analyze~chunk-pie-embed~chunk-share":"chunk-analyze~chunk-pie-embed~chunk-share","chunk-analyze~chunk-share":"chunk-analyze~chunk-share","chunk-analyze":"chunk-analyze","chunk-share":"chunk-share","chunk-pie-embed":"chunk-pie-embed","chunk-area-embed":"chunk-area-embed","chunk-bar-embed":"chunk-bar-embed","chunk-category-settings~client-chunk-about~client-chunk-entries":"chunk-category-settings~client-chunk-about~client-chunk-entries","client-chunk-about~client-chunk-entries~client-chunk-goals":"client-chunk-about~client-chunk-entries~client-chunk-goals","client-chunk-entries":"client-chunk-entries","client-chunk-about":"client-chunk-about","chunk-projections":"chunk-projections","client-chunk-avocados":"client-chunk-avocados","chunk-billing":"chunk-billing","chunk-category-settings~client-chunk-entry-editor":"chunk-category-settings~client-chunk-entry-editor","chunk-category-settings":"chunk-category-settings","client-chunk-entry-editor":"client-chunk-entry-editor","chunk-firestore":"chunk-firestore","chunk-xlsx-parser~chunk-zipcelx":"chunk-xlsx-parser~chunk-zipcelx","chunk-zipcelx":"chunk-zipcelx","client-chunk-about-sharesight":"client-chunk-about-sharesight","client-chunk-goals":"client-chunk-goals","client-chunk-appboot":"client-chunk-appboot","client-chunk-authentication":"client-chunk-authentication","client-chunk-calculator":"client-chunk-calculator","client-chunk-export":"client-chunk-export","client-chunk-import":"client-chunk-import","client-chunk-integrations":"client-chunk-integrations","client-chunk-legal":"client-chunk-legal","client-chunk-mail-preferences":"client-chunk-mail-preferences","client-chunk-plans":"client-chunk-plans","client-chunk-sharesight":"client-chunk-sharesight","client-chunk-user-email-invalid":"client-chunk-user-email-invalid","client-chunk-user-settings":"client-chunk-user-settings","chunk-xlsx-parser":"chunk-xlsx-parser"}[chunkId]||chunkId) + "." + {"chunk-admin":"54896b1e","chunk-analyze~chunk-area-embed~chunk-bar-embed~chunk-pie-embed~chunk-projections~chunk-share~client-~87dfe4db":"31d6cfe0","chunk-analyze~chunk-pie-embed~chunk-share":"31d6cfe0","chunk-analyze~chunk-share":"8a8881b0","chunk-analyze":"0fc9b40d","chunk-share":"686d3bc7","chunk-pie-embed":"0cccad59","chunk-area-embed":"ac51d8cd","chunk-bar-embed":"2537122c","chunk-category-settings~client-chunk-about~client-chunk-entries":"225c8719","client-chunk-about~client-chunk-entries~client-chunk-goals":"36d9efd1","client-chunk-entries":"b48a1a74","client-chunk-about":"99b7dd85","chunk-projections":"1ddd0fca","client-chunk-avocados":"568d0c32","chunk-billing":"ad70d7f4","chunk-category-settings~client-chunk-entry-editor":"cd6f4b37","chunk-category-settings":"2a6a15c3","client-chunk-entry-editor":"bc6cc2ec","chunk-firestore":"31d6cfe0","chunk-xlsx-parser~chunk-zipcelx":"31d6cfe0","chunk-zipcelx":"31d6cfe0","client-chunk-about-sharesight":"c9b774f1","client-chunk-goals":"c082a024","client-chunk-appboot":"ad9a08f0","client-chunk-authentication":"31b8a5e1","client-chunk-calculator":"ce3ad798","client-chunk-export":"a8004645","client-chunk-import":"43c36b1b","client-chunk-integrations":"692f6617","client-chunk-legal":"c43307d4","client-chunk-mail-preferences":"b11305c6","client-chunk-plans":"8e727bfb","client-chunk-sharesight":"b677acf8","client-chunk-user-email-invalid":"31d6cfe0","client-chunk-user-settings":"04cfec81","chunk-xlsx-parser":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
